import { AuthState, AuthStateModel } from '../store/state/auth/auth.state';
import { CurrencyState, CurrencyStateModel } from '../../shared/store/state/currency/currency.state';
import { FilterObjectState, FilterObjectStateModel } from 'src/app/shared/store/state/filter-object/filter-object.state';
import { PreferencesState, PreferencesStateModel } from 'src/app/shared/store/state/preferences/preferences.state';
import { ReportsStateModel, ReportsState } from '@trovata/app/features/reports/store/state/reports.state';
import { CoreState, CoreStateModel } from '../store/state/core/core.state';
import { InitCoreState } from '../store/actions/core.actions';
import { ClearReportsState, InitReportsState } from 'src/app/features/reports/store/actions/reports.actions';
import { ClearPreferencesState, InitPreferencesState } from 'src/app/shared/store/actions/preferences.actions';
import { ClearCurrencyState, InitCurrencyState } from 'src/app/shared/store/actions/currency.actions';
import { ClearFilterObjectState, InitFilterObjectState } from 'src/app/shared/store/actions/filter-object.actions';
import { PaymentsAccountsState, PaymentsAccountsStateModel } from '../../features/payments/store/state/accounts/accounts.state';
import { TemplatesState, TemplatesStateModel } from '../../features/payments/store/state/templates/templates.state';
import { PaymentsState, PaymentsStateModel } from '../../features/payments/store/state/payments/payments.state';
import { WorkflowsState, WorkflowsStateModel } from '../../features/payments/store/state/workflows/workflow.state';
import { ClearPaymentsAccountsState, InitPaymentsAccountsState } from '../../features/payments/store/actions/accounts.actions';
import { ClearTemplatesState, InitTemplatesState } from '../../features/payments/store/actions/templates.actions';
import { ClearPaymentsState, InitPaymentsState } from '../../features/payments/store/actions/payments.actions';
import { ClearWorkflowsState, InitWorkflowsState } from '../../features/payments/store/actions/workflows.actions';
import { MOCK_ACCOUNTS, MOCK_INSTITUTION_INSTRUCTIONS } from '../../features/payments/models/account.model';
import { PaymentsTab } from '../../features/payments/models/payment.model';
import { MOCK_WORKFLOWS } from '../../features/payments/models/workflow.model';
import { TagsState, TagsStateModel } from '../../features/transactions/store/state/tags.state';
import { ClearTagsState, InitTagsState } from '../../features/transactions/store/actions/tags.action';
import { InstitutionsState, InstitutionsStateModel } from '../../shared/store/state/institutions/institutions.state';
import { InitInstitutionsState, ClearInstitutionsState } from '../../shared/store/actions/institutions.actions';
import { ReconciliationState, ReconciliationStateModel } from '../../features/reconciliation/store/state/reconciliation.state';
import { ClearReconciliationState, InitReconciliationState } from '../../features/reconciliation/store/actions/reconciliation.actions';
import { MOCK_TEMPLATES } from '../../features/payments/models/template.model';
import { ForecastV3State, ForecastV3StateModel } from '../../features/forecasts/store/state/forecastV3.state';
import { ClearForecastV3State, InitForecastV3State } from '../../features/forecasts/store/actions/forecastV3.action';
import { ClearCurrentCashState, InitCurrentCashState } from '../../features/balances/store/actions/current-cash.actions';
import { CurrentCashState, CurrentCashStateModel } from '../../features/balances/store/state/current-cash/current-cash.state';
import { CustomerFeatureState, CustomerFeatureStateModel } from '../../features/settings/store/state/customer-feature.state';
import { ClearCustomerFeatureState, InitCustomerFeatureState } from '../../features/settings/store/actions/customer-feature.actions';
import { IdentityState, IdentityStateModel } from '../../features/settings/store/state/identity.state';
import { ClearIdentityState, InitIdentityState } from '../../features/settings/store/actions/identity.actions';
import { EntitlementsState, EntitlementsStateModel } from '../../features/settings/store/state/entitlements.state';
import { ClearEntitlementsState, InitEntitlementsState } from '../../features/settings/store/actions/entitlements.actions';
import { PlaidState, PlaidStateModel } from '../../features/settings/store/state/plaid.state';
import { ClearPlaidState, InitPlaidState } from '../../features/settings/store/actions/plaid.actions';
import { CustomerUsersState, CustomerUsersStateModel } from '../../features/settings/store/state/customer-users.state';
import { ClearCustomerUsersState, InitCustomerUsersState } from '../../features/settings/store/actions/customer-users.actions';
import { TagSnacksState, TagSnacksStateModel } from '../../features/transactions/store/state/tag-snacks.state';
import { ClearTagSnacksState, InitTagSnacksState } from '../../features/transactions/store/actions/tag-snacks.action';
import { GlTagsState, GlTagsStateModel } from '../../features/transactions/store/state/glTags.state';
import { ClearGlTagsState, InitGlTagsState } from '../../features/transactions/store/actions/glTags.action';
import { GlCodesState, GlCodeStateModel } from '../../features/transactions/store/state/glCode.state';
import { ClearGlCodeState, InitGlCodeState } from '../../features/transactions/store/actions/glCode.action';
import { TransactionsState, TransactionsStateModel } from '../../features/transactions/store/state/transactions.state';
import { ClearTransactionsState } from '../../features/transactions/store/actions/transactions.action';
import { CashPositionState, CashPositionStateModel } from '../../features/cash-position/store/state/cash-position.state';
import { ClearCashPositionState, InitCashPositionState } from '../../features/cash-position/store/actions/cash-position.actions';
import { ConsentManagementState, ConsentManagementStateModel } from '../../features/settings/store/state/consent-management.state';
import { ClearConsentManagementState, InitConsentManagementState } from '../../features/settings/store/actions/consent-management.actions';
import { ConnectionsState, ConnectionsStateModel } from '../../features/multi-bank-connect/store/state/connections.state';
import { MOCK_AUTH_USER } from './auth.model';
import { TQLFieldsState, TQLFieldsStateModel } from '@trovata/app/features/tql/store/state/tql-fields/tql-fields.state';
import { ClearTQLFieldsState, InitTQLFieldsState } from '@trovata/app/features/tql/store/actions/tql-fields.actions';
import { AuditLogsState, AuditLogsStateModel } from '@trovata/app/shared/store/state/audit-logs/audit-logs.state';
import { ClearAuditLogsState, InitAuditLogsState } from '@trovata/app/shared/store/actions/audit-log.actions';
import { InitEntitiesState, ClearEntitiesState } from '../../features/entities/store/actions/entities.actions';
import { EntitiesStateModel, EntitiesState } from '../../features/entities/store/state/entities.state';
import { InitWorkbooksState, ClearWorkbooksState } from '../../features/workbooks/store/actions/workbooks.actions';
import { WorkbooksStateModel, WorkbooksState } from '../../features/workbooks/store/state/workbooks.state';
import { DeveloperPortalApplicationsStateModel, DeveloperPortalApplicationsState } from '../../features/developer-portal/store/state/applications.state';
import {
	InitDeveloperPortalApplicationsState,
	ClearDeveloperPortalApplicationsState,
} from '@trovata/app/features/developer-portal/store/actions/applications.actions';
import { ClearDeveloperPortalResourcesState } from '@trovata/app/features/developer-portal/store/actions/resources.actions';
import { DeveloperPortalResourcesState, DeveloperPortalResourcesStateModel } from '@trovata/app/features/developer-portal/store/state/resources.state';
import { ShareState, ShareStateModel } from '@trovata/app/shared/store/state/shares/share.state';
import { ClearShareState, InitShareState } from '@trovata/app/shared/store/actions/share.actions';
import { InitStatementsState } from 'src/app/features/statements/store/actions/statements.actions';
import { StatementsState, StatementsStateModel } from 'src/app/features/statements/store/state/statements.state';
import { HomeState, HomeStateModel } from '@trovata/app/features/home/store/state/home.state';
import { ClearHomeState, InitHomeState } from '@trovata/app/features/home/store/actions/home.action';
import { InstructionsState, InstructionsStateModel } from '@trovata/app/features/payments/store/state/instructions/instructions.state';
import { ClearInstructionsState, InitInstructionsState } from '@trovata/app/features/payments/store/actions/instructions.actions';
import { ClearConnectionsState, InitConnectionsState } from '@trovata/app/features/multi-bank-connect/store/actions/connections.actions';
import { AgentsState, AgentsStateModel } from '@trovata/app/features/ai-agents/store/state/agents.state';
import { ClearAgentsState, InitAgentsState } from '@trovata/app/features/ai-agents/store/actions/agents.actions';
import { StablecoinWalletsState, StablecoinWalletsStateModel } from '@trovata/app/features/stablecoin/store/state/wallets/wallets.state';
import { StablecoinTransfersState, StablecoinTransfersStateModel } from '@trovata/app/features/stablecoin/store/state/transfers/transfers.state';
import { StablecoinReportsState, StablecoinReportsStateModel } from '@trovata/app/features/stablecoin/store/state/reports/reports.state';
import { StablecoinWorkflowsState, StablecoinWorkflowsStateModel } from '@trovata/app/features/stablecoin/store/state/workflows/workflows.state';
import { ClearStablecoinWalletsState, InitStablecoinWalletsState } from '@trovata/app/features/stablecoin/store/actions/wallets.actions';
import { ClearStablecoinTransfersState, InitStablecoinTransfersState } from '@trovata/app/features/stablecoin/store/actions/transfers.actions';
import { ClearStablecoinReportsState, InitStablecoinReportsState } from '@trovata/app/features/stablecoin/store/actions/reports.actions';
import { ClearStablecoinWorkflowsState, InitStablecoinWorkflowsState } from '@trovata/app/features/stablecoin/store/actions/workflows.actions';
import { ChatSessionsState, ChatSessionsStateModel } from '@trovata/app/features/chat-assistant/store/state/chat-sessions.state';
import { ClearChatSessionsState } from '@trovata/app/features/chat-assistant/store/actions/chat-sessions.actions';

export const TrovataAppStateKey: string = '@@STATE';

export interface TrovataAppState {
	core: CoreStateModel;
	authorization: AuthStateModel;
	preferences: PreferencesStateModel;
	filterObject: FilterObjectStateModel;
	cashPosition: CashPositionStateModel;
	currentCash: CurrentCashStateModel;
	currency: CurrencyStateModel;
	home: HomeStateModel;
	reports: ReportsStateModel;
	forecastV3: ForecastV3StateModel;
	reconciliation: ReconciliationStateModel;
	customerFeature: CustomerFeatureStateModel;
	customerUsers: CustomerUsersStateModel;
	tags: TagsStateModel;
	tqlFields: TQLFieldsStateModel;
	glTags: GlTagsStateModel;
	glCodes: GlCodeStateModel;
	tagSnacks: TagSnacksStateModel;
	transactions: TransactionsStateModel;
	institutions: InstitutionsStateModel;
	payments: PaymentsStateModel;
	instructions: InstructionsStateModel;
	paymentsAccounts: PaymentsAccountsStateModel;
	templates: TemplatesStateModel;
	workflows: WorkflowsStateModel;
	identity: IdentityStateModel;
	entitlements: EntitlementsStateModel;
	plaid: PlaidStateModel;
	connections: ConnectionsStateModel;
	consentManagement: ConsentManagementStateModel;
	auditLogs: AuditLogsStateModel;
	entities: EntitiesStateModel;
	workbooks: WorkbooksStateModel;
	developerApplications: DeveloperPortalApplicationsStateModel;
	developerResources: DeveloperPortalResourcesStateModel;
	share: ShareStateModel;
	statements: StatementsStateModel;
	agents: AgentsStateModel;
	stablecoinWallets: StablecoinWalletsStateModel;
	stablecoinTransfers: StablecoinTransfersStateModel;
	stablecoinReports: StablecoinReportsStateModel;
	stablecoinWorkflows: StablecoinWorkflowsStateModel;
	chatSessions: ChatSessionsStateModel;
}

export type TrovataAppStates = [
	typeof CoreState,
	typeof AuthState,
	typeof PreferencesState,
	typeof FilterObjectState,
	typeof CashPositionState,
	typeof CurrentCashState,
	typeof TagsState,
	typeof TQLFieldsState,
	typeof GlTagsState,
	typeof GlCodesState,
	typeof TagSnacksState,
	typeof TransactionsState,
	typeof CurrencyState,
	typeof HomeState,
	typeof ReportsState,
	typeof ForecastV3State,
	typeof ReconciliationState,
	typeof CustomerFeatureState,
	typeof CustomerUsersState,
	typeof InstitutionsState,
	typeof PaymentsState,
	typeof InstructionsState,
	typeof PaymentsAccountsState,
	typeof TemplatesState,
	typeof WorkflowsState,
	typeof IdentityState,
	typeof EntitlementsState,
	typeof PlaidState,
	typeof ConsentManagementState,
	typeof ConnectionsState,
	typeof AuditLogsState,
	typeof EntitiesState,
	typeof WorkbooksState,
	typeof DeveloperPortalApplicationsState,
	typeof DeveloperPortalResourcesState,
	typeof ShareState,
	typeof StatementsState,
	typeof AgentsState,
	typeof StablecoinWalletsState,
	typeof StablecoinTransfersState,
	typeof StablecoinReportsState,
	typeof StablecoinWorkflowsState,
	typeof ChatSessionsState,
];

export const TROVATA_APP_STATES: TrovataAppStates = [
	CoreState,
	AuthState,
	PreferencesState,
	FilterObjectState,
	CashPositionState,
	CurrentCashState,
	TagsState,
	TQLFieldsState,
	GlTagsState,
	GlCodesState,
	TagSnacksState,
	TransactionsState,
	CurrencyState,
	HomeState,
	ReportsState,
	ForecastV3State,
	ReconciliationState,
	CustomerFeatureState,
	CustomerUsersState,
	InstitutionsState,
	PaymentsState,
	InstructionsState,
	PaymentsAccountsState,
	TemplatesState,
	WorkflowsState,
	IdentityState,
	EntitlementsState,
	PlaidState,
	ConsentManagementState,
	ConnectionsState,
	AuditLogsState,
	EntitiesState,
	WorkbooksState,
	DeveloperPortalApplicationsState,
	DeveloperPortalResourcesState,
	ShareState,
	StatementsState,
	AgentsState,
	StablecoinWalletsState,
	StablecoinTransfersState,
	StablecoinReportsState,
	StablecoinWorkflowsState,
	ChatSessionsState,
];

export type TrovataAppStateToInit =
	| typeof InitCoreState
	| typeof InitPreferencesState
	| typeof InitFilterObjectState
	| typeof CashPositionState
	| typeof InitCurrencyState
	| typeof InitReportsState
	| typeof InitForecastV3State
	| typeof InitCurrentCashState
	| typeof InitReconciliationState
	| typeof InitCustomerFeatureState
	| typeof InitCustomerUsersState
	| typeof InitHomeState
	| typeof InitTagsState
	| typeof TQLFieldsState
	| typeof InitGlTagsState
	| typeof InitGlCodeState
	| typeof InitTagSnacksState
	| typeof InitInstitutionsState
	| typeof InitPaymentsState
	| typeof InitInstructionsState
	| typeof InitPaymentsAccountsState
	| typeof InitTemplatesState
	| typeof InitWorkflowsState
	| typeof InitIdentityState
	| typeof InitEntitlementsState
	| typeof InitPlaidState
	| typeof InitConsentManagementState
	| typeof InitConnectionsState
	| typeof InitAuditLogsState
	| typeof InitEntitiesState
	| typeof WorkbooksState
	| typeof DeveloperPortalApplicationsState
	| typeof DeveloperPortalResourcesState
	| typeof ShareState
	| typeof StatementsState
	| typeof InitAgentsState
	| typeof InitStablecoinWalletsState
	| typeof InitStablecoinTransfersState
	| typeof InitStablecoinReportsState
	| typeof InitStablecoinWorkflowsState;

export type TrovataIndependentStateToInit =
	| typeof InitCurrencyState
	| typeof InitTQLFieldsState
	| typeof InitPreferencesState
	| typeof InitFilterObjectState
	| typeof InitEntitlementsState
	| typeof InitConsentManagementState
	| typeof InitConnectionsState;

export const TROVATA_INDEPENDENT_STATES_TO_INIT: TrovataIndependentStateToInit[] = [
	InitCurrencyState,
	InitTQLFieldsState,
	InitPreferencesState,
	InitFilterObjectState,
	InitEntitlementsState,
	InitConsentManagementState,
	InitConnectionsState,
];

export const TROVATA_APP_STATES_TO_INIT: TrovataAppStateToInit[] = [
	InitIdentityState,
	InitInstitutionsState,
	InitEntitiesState,
	InitHomeState,
	InitGlTagsState,
	InitGlCodeState,
	InitTagsState,
	InitStatementsState,
	InitCashPositionState,
	InitReportsState,
	InitReconciliationState,
	InitForecastV3State,
	InitCurrentCashState,
	InitCustomerUsersState,
	InitTagSnacksState,
	InitPaymentsState,
	InitPaymentsAccountsState,
	InitTemplatesState,
	InitWorkflowsState,
	InitPlaidState,
	InitAuditLogsState,
	InitWorkbooksState,
	InitDeveloperPortalApplicationsState,
	InitShareState,
	InitAgentsState,
	InitStablecoinWalletsState,
	InitStablecoinTransfersState,
	InitStablecoinReportsState,
	InitStablecoinWorkflowsState,
];

export type TrovataAppStateToClear =
	| typeof ClearPreferencesState
	| typeof ClearFilterObjectState
	| typeof ClearCashPositionState
	| typeof ClearCurrencyState
	| typeof ClearHomeState
	| typeof ClearReportsState
	| typeof ClearForecastV3State
	| typeof ClearReconciliationState
	| typeof ClearCustomerFeatureState
	| typeof ClearCustomerUsersState
	| typeof ClearTagsState
	| typeof ClearGlTagsState
	| typeof ClearGlCodeState
	| typeof ClearTagSnacksState
	| typeof ClearTransactionsState
	| typeof ClearTQLFieldsState
	| typeof ClearInstitutionsState
	| typeof ClearCurrentCashState
	| typeof ClearIdentityState
	| typeof ClearEntitlementsState
	| typeof ClearPlaidState
	| typeof ClearConsentManagementState
	| typeof ClearConnectionsState
	| typeof ClearAuditLogsState
	| typeof ClearEntitiesState
	| typeof ConnectionsState
	| typeof ClearWorkbooksState
	| typeof ClearShareState
	| typeof ClearDeveloperPortalApplicationsState
	| typeof ClearDeveloperPortalResourcesState
	| typeof ClearAgentsState
	| typeof ClearStablecoinWalletsState
	| typeof ClearStablecoinTransfersState
	| typeof ClearStablecoinReportsState
	| typeof ClearStablecoinWorkflowsState
	| typeof ClearChatSessionsState;

export const TROVATA_APP_STATES_TO_CLEAR: TrovataAppStateToClear[] = [
	ClearPreferencesState,
	ClearFilterObjectState,
	ClearCashPositionState,
	ClearCurrentCashState,
	ClearCurrencyState,
	ClearHomeState,
	ClearReportsState,
	ClearForecastV3State,
	ClearReconciliationState,
	ClearCustomerFeatureState,
	ClearCustomerUsersState,
	ClearTagsState,
	ClearTQLFieldsState,
	ClearGlTagsState,
	ClearGlCodeState,
	ClearTagSnacksState,
	ClearTransactionsState,
	ClearInstitutionsState,
	ClearIdentityState,
	ClearEntitlementsState,
	ClearPlaidState,
	ClearConsentManagementState,
	ClearConnectionsState,
	ClearAuditLogsState,
	ClearEntitiesState,
	ClearWorkbooksState,
	ClearShareState,
	ClearDeveloperPortalApplicationsState,
	ClearDeveloperPortalResourcesState,
	ClearAgentsState,
	ClearStablecoinWalletsState,
	ClearStablecoinTransfersState,
	ClearStablecoinReportsState,
	ClearStablecoinWorkflowsState,
	ClearChatSessionsState,
];

export const TROVATA_FEATURE_STATES_TO_INIT: TrovataAppStateToInit[] = [
	InitPreferencesState,
	InitFilterObjectState,
	InitCashPositionState,
	InitCurrentCashState,
	InitHomeState,
	InitReportsState,
	InitForecastV3State,
	InitReconciliationState,
	InitTagsState,
	InitTQLFieldsState,
	InitGlTagsState,
	InitGlCodeState,
	InitTagSnacksState,
	InitInstitutionsState,
	InitPlaidState,
	InitConsentManagementState,
	InitAuditLogsState,
	InitEntitiesState,
	InitWorkbooksState,
	InitDeveloperPortalApplicationsState,
	InitShareState,
	InitStatementsState,
	InitAgentsState,
	InitStablecoinWalletsState,
	InitStablecoinTransfersState,
	InitStablecoinReportsState,
	InitStablecoinWorkflowsState,
];

export type TrovataStateAction = TrovataAppStateToInit | TrovataAppStateToClear | TrovataIndependentStateToInit;

export const TROVATA_FEATURE_STATES_TO_CLEAR: TrovataAppStateToClear[] = [
	ClearPreferencesState,
	ClearFilterObjectState,
	ClearCashPositionState,
	ClearCurrentCashState,
	ClearHomeState,
	ClearReportsState,
	ClearForecastV3State,
	ClearReconciliationState,
	ClearTagsState,
	ClearTQLFieldsState,
	ClearGlTagsState,
	ClearGlCodeState,
	ClearTagSnacksState,
	ClearTransactionsState,
	ClearInstitutionsState,
	ClearPlaidState,
	ClearConsentManagementState,
	ClearAuditLogsState,
	ClearEntitiesState,
	ClearWorkbooksState,
	ClearDeveloperPortalApplicationsState,
	ClearDeveloperPortalResourcesState,
	ClearShareState,
	ClearAgentsState,
	ClearStablecoinWalletsState,
	ClearStablecoinTransfersState,
	ClearStablecoinReportsState,
	ClearStablecoinWorkflowsState,
	ClearChatSessionsState,
];

export type TrovataPaymentsStatesToInit =
	| typeof InitPaymentsState
	| typeof InitPaymentsAccountsState
	| typeof InitTemplatesState
	| typeof InitWorkflowsState
	| typeof InitInstructionsState;

export const TROVATA_PAYMENTS_STATES_TO_INIT: TrovataAppStateToInit[] = [
	InitPaymentsState,
	InitPaymentsAccountsState,
	InitTemplatesState,
	InitWorkflowsState,
	InitInstructionsState,
];

export type TrovataPaymentsStateToClear =
	| typeof ClearPaymentsState
	| typeof ClearPaymentsAccountsState
	| typeof ClearTemplatesState
	| typeof ClearWorkflowsState
	| typeof ClearInstructionsState;

export const TROVATA_PAYMENTS_STATES_TO_CLEAR: TrovataPaymentsStateToClear[] = [
	ClearPaymentsState,
	ClearPaymentsAccountsState,
	ClearTemplatesState,
	ClearWorkflowsState,
	ClearInstructionsState,
];

export const MOCK_CORE_STATE: CoreStateModel = { appReady: true, uatEnvironment: false, connectionCount: null };

export const MOCK_PAYMENTS_STATE: PaymentsStateModel = {
	selectedTab: PaymentsTab.allPayments,
	allPaymentsError: false,
	reviewPaymentsError: false,
	openPaymentsError: false,
	apiErrors: [],
	allPaymentsTableQuery: {},
	allPaymentsTableTotalCount: 0,
	openPaymentsTableQuery: {},
	openPaymentsTableTotalCount: 0,
	readyForReviewTableQuery: {},
	readyForReviewTableTotalCount: 0,
	isAllPaymentsLoading: true,
	isOpenPaymentsLoading: true,
	isReadyForReviewLoading: true,
	areSnacksLoading: true,
	paymentRecordEntities: {},
	allPaymentsTableIds: [],
	openPaymentsTableIds: [],
	reviewPaymentsTableIds: [],
	paymentsSnacks: [],
	batchIdsLoadingChildren: [],
	batchIdsWithChildLoadError: [],
};

export const MOCK_WORKFLOWS_STATE: WorkflowsStateModel = {
	workflows: MOCK_WORKFLOWS,
	workflowSnacks: [],
	isCached: true,
	apiErrors: [],
	workflowsLoading: true,
};

export const MOCK_ACCOUNTS_STATE: PaymentsAccountsStateModel = {
	accounts: MOCK_ACCOUNTS,
	institutionInstructions: MOCK_INSTITUTION_INSTRUCTIONS,
	accountSnacks: [],
	isCached: true,
	apiErrors: [],
	accountsLoading: true,
};

export const MOCK_TEMPLATES_STATE: TemplatesStateModel = {
	templates: MOCK_TEMPLATES,
	institutionMap: null,
	countriesDict: null,
	templateSnacks: [],
	isCached: true,
	apiErrors: [],
	templatesLoading: true,
};

export const MOCK_AUTH_STATE: AuthStateModel = {
	accessToken: 'test',
	refreshToken: 'test',
	authUser: MOCK_AUTH_USER,
	authenticated: true,
	authErrorMessage: 'test',
	loggedIn: false,
};
